import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const GetProductModalBarcodesDocument = gql`
  query GetProductModalBarcodes($productId: Int!) {
    product(id: $productId) {
      id
      barcodes {
        unpaginated {
          id
          body
          organisation {
            id
          }
        }
        totalCount
      }
    }
  }
` as unknown as DocumentNode<Types.GetProductModalBarcodesQuery, Types.GetProductModalBarcodesQueryVariables>
